import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import {
    HelpModal,
    HelpModalOverlay,
    HelpModalTitle,
    HelpModalContent,
    HelpModalClose
} from './Modal.styles';

const Modal = ({ title, content, onClose }) => {
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [onClose]);

    return (
        <>
            <HelpModalOverlay onClick={onClose} />
            <HelpModal>
                <HelpModalTitle>{title}</HelpModalTitle>
                <HelpModalClose onClick={onClose}>
                    <FontAwesomeIcon icon={faTimes} />
                </HelpModalClose>
                <HelpModalContent>{content}</HelpModalContent>
            </HelpModal>
        </>
    );
};

export default Modal; 